import { render, staticRenderFns } from "./LogisticsDashBoard.vue?vue&type=template&id=a086d7e0&scoped=true&"
import script from "./LogisticsDashBoard.vue?vue&type=script&lang=js&"
export * from "./LogisticsDashBoard.vue?vue&type=script&lang=js&"
import style0 from "./LogisticsDashBoard.vue?vue&type=style&index=0&id=a086d7e0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a086d7e0",
  null
  
)

export default component.exports